import component from './EmptyState.vue'

export default component
export { default as WithEmptyState } from './WithEmptyState.vue'
